<template>
    <div class="card">
        <div class="card-content">
            <div class="content">

                <b-field label="Nom du site/projet">
                    <section class="b-tooltips">
                        <b-input v-model="project.readablename"
                                 type="text"
                                 maxlength="50"
                                 required>
                        </b-input>
                    </section>
                </b-field>

                <b-field grouped>

                    <b-field label="N° dépt ou 99">
                        <section class="b-tooltips">
                            <b-tooltip
                                type="is-info"
                                label="99 pour les projets inter-régionnaux"
                                multilined
                                size="is-large"
                                position="is-bottom">
                                <b-select
                                    placeholder="00"
                                    v-model="project.anal"
                                    required
                                    :disabled="rev">
                                    <option
                                        v-for="option in [16, 17, 19, 23, 24, 33, 40, 47, 64, 79, 86, 87, 99]"
                                        :value="option"
                                        :key="option">
                                        {{ option }}
                                    </option>
                                </b-select>
                            </b-tooltip>
                        </section>
                    </b-field>

                    <b-field label="Code analytique du projet / site">
                        <section class="b-tooltips">
                            <b-tooltip
                                type="is-info"
                                label="Ne pas saisir de dispositif ou de nom de phase."
                                multilined
                                size="is-large"
                                position="is-bottom">
                                <b-input v-model="project.name"
                                         type="text"
                                         maxlength="6"
                                         minlength="6"
                                         pattern="[A-Z0-9]{6}"
                                         title="6 caractères alphanumériques (A-Z, 0-9)"
                                         @input="formatCodeAnalytique"
                                         required
                                         :disabled="rev">
                                </b-input>
                            </b-tooltip>
                        </section>
                    </b-field>
                    <b-field label="Année">
                        <b-select v-model="project.year"
                                  required
                                  :disabled="rev"
                                  placeholder="Sélectionnez une année">
                            <option
                                v-for="year in years"
                                :value="year"
                                :key="year">
                                {{ year }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Type">
                        <b-select placeholder="Sélectionner"
                                  v-model="project.type"
                                  required
                                  :disabled="rev"
                                  @input="resetDispositif()">
                            <option
                                v-for="option in type"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="Maitre d'ouvrage"
                             v-if="project.type === 'Prestation'"
                             required>
                        <b-select placeholder="Sélectionner"
                                  v-model="project.maitre"
                        >
                            <option
                                v-for="option in maitre"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-tooltip>
                        <b-field label="Frais généraux CTMA">
                            <b-checkbox
                                v-model="project.ctma"
                                size="is-medium">
                            </b-checkbox>
                        </b-field>
                        <template v-slot:content>
                            <span v-html="formula()"></span>
                        </template>
                    </b-tooltip>
                </b-field>
                <b-field grouped>

                    <b-field label="Dispositif financier - 'Prestation'"
                             v-if="project.type === 'Prestation'">
                        <b-select placeholder="Sélectionner"
                                  v-model="project.dispositif"
                                  required
                                  :disabled="rev">
                            <option
                                v-for="option in prestation"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="Dispositif financier - 'Subvention'"
                             v-if="project.type === 'Subvention'
                   || project.type === 'Subvention sans frais généraux'
                   || project.type === 'Charge uniquement ⚠️'">
                        <b-select placeholder="Sélectionner"
                                  v-model="project.dispositif"
                                  :disabled="rev">
                            <option
                                v-for="option in subvention"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Type d'action du Projet (phase)">
                        <b-select placeholder="Sélectionner"
                                  v-model="project.phase"
                                  :disabled="rev">
                            <option
                                v-for="option in phase"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Ajuster le coût-jour HT en €"
                             v-if="project.type === 'Prestation'">

                        <b-input placeholder="Renseigner le coût-jour"
                                 v-model="project.forfaitpresta"
                                 type="number"
                                 step="0.01"
                        >
                        </b-input>

                        <span
                            v-if="project.forfaitpresta < coutderevient">
               <b-icon icon="exclamation-circle"
                       class="m-2"
                       type="is-danger">
               </b-icon>
              La marge sera négative
            </span>

                        <!--
                        <b-select v-model="project.forfaitpresta"
                                  placeholder="Sélectionner un coût"
                        >
                          <option
                              v-for="option in forfaitsPresta"
                              :value="option"
                              :key="option"
                          >
                            {{ option }}
                          </option>
                        </b-select>
                        -->

                    </b-field>

                </b-field>

                <b-field label="Dossier">
                    <b-taginput placeholder="Ajouter un dossier"
                                :data="folders"
                                autocomplete
                                open-on-focus
                                icon="folder"
                                v-model="project.dossiers">
                    </b-taginput>
                </b-field>

            </div>
        </div>
    </div>
</template>

<script>

import katex from "katex";

export default {
    name: "Project",
    props: {
        rev: {
            required: true
        }
    },
    mounted() {
        if (localStorage.getItem("project")) {
            this.project = JSON.parse(localStorage.getItem("project"));
        } else {
            // Initialiser un projet vide - l'année sera sélectionnée par l'utilisateur
            this.project = {};
        }

        this.$axios.get('ref/project', {})
            .then((res) => {
                console.log(res.data)
                this.prestation = res.data.project.ref.prestation;
                this.subvention = res.data.project.ref.subvention;
                this.phase = res.data.project.ref.phase;
                this.years = res.data.project.ref.years;
                this.maitre = res.data.project.ref.maitre;
                this.folders = res.data.folders;
            })
        // Load conf
        this.$axios.get('conf', {})
            .then((conf) => {
                this.coutderevient = conf.data.conf.conf.coutderevient
            });
    },
    computed: {
        projectName() {
            let final = '';
            final = this.project.anal ? this.project.anal : 'XX';
            final += this.project.name ? this.project.name.toUpperCase() : 'XXXXXX';
            final += this.project.year ? `_${this.project.year.slice(2, 4)}` : '_XX';
            final += this.project.type ? `_${this.project.type.slice(0, 1)}` : '_X';
            let d = this.project.dispositif ? this.project.dispositif.split(" - ") : '_XXXX';
            final += `_${d[d.length - 1]}`;
            return final;
        },
    },
    watch: {
        // whenever var changes, this function will run
        // project: function (newProject, oldProject) {
        project: {
            handler() {
                console.log('Automatic save')
                if (this.project.type === 'Subvention'
                    || this.project.type === 'Subvention sans frais généraux'
                    || this.project.type === 'Charge uniquement ⚠️'
                ) {
                    delete this.project.maitre
                    this.$set(this.project, 'forfaitpresta', null)
                }
                this.project.fullName = this.projectName;

                localStorage.setItem("project", JSON.stringify(this.project));
                this.$emit('projectName', this.projectName);
                this.$emit('projectDayCost', this.project.forfaitpresta);
                this.$emit('ProjectNameReadable', this.project.readablename);
                this.$emit('projectPhase', this.project.phase);
                this.$emit('projectType', this.project.type);
                this.$emit('project', this.project);
                // Validity control
                this.$emit('next', this.check());
            },
            deep: true
        }
    },
    methods: {
        formula() {
            return katex.renderToString("\\text{Frais généraux}=\\left(\\frac{\\text{Nb jours sans support}\\times12000}{210}\\right)-\\text{Frais de mission}", {
                throwOnError: false,
            })
        },
        formatCodeAnalytique() {
            if (this.project.name) {
                // Supprimer espaces, caractères spéciaux et convertir en majuscules
                this.project.name = this.project.name
                    .replace(/[^A-Za-z0-9]/g, '') // Garde lettres et chiffres, supprime espaces et caractères spéciaux
                    .toUpperCase() // Convertit en majuscules
                    .slice(0, 6); // Limite à 6 caractères
            }
        },
        resetDispositif() {
            delete this.project.dispositif;
        },
        check() {
            // Check validity
            let checklist = [];
            checklist.push(("type" in this.project) && this.project.name.length === 6 && this.project.anal > 0)
            checklist.push(("year" in this.project))
            checklist.push(("dispositif" in this.project))
            checklist.push(("phase" in this.project))
            checklist.push(("forfaitpresta" in this.project))
            if ("maitre" in this.project) {
                checklist.push(this.project.forfaitpresta > 0)
            }
            checklist.push(this.project.type === 'Prestation' && ("maitre" in this.project)
                || this.project.type === 'Subvention'
                || this.project.type === 'Subvention sans frais généraux'
                || this.project.type === 'Charge uniquement ⚠️')
            // console.log(checklist)
            return !checklist.includes(false)
        }
    },
    data() {
        return {
            project: {},
            type: ['Subvention', 'Subvention sans frais généraux', 'Prestation', 'Charge uniquement ⚠️'],
            prestation: [],
            subvention: [],
            phase: [],
            years: [],
            maitre: [],
            folders: [],
            coutderevient: null,
        }
    },

}

</script>

<style scoped>

</style>
